export default "__VITE_ASSET__CkIvOBWt__"